import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['observableElement', 'scrollToElement']

  connect() {
    this.mutationObserver = new MutationObserver(this.onMutation);
    this.observeMutations();
    this.intersectionObserver = new IntersectionObserver(this.onIntersection);
    this.intersectionObserver.observe(this.scrollToElementTarget);
  }

  observeMutations() {
    this.mutationObserver.observe(this.observableElement, { attributes: true, childList: true, subtree: true });
  }

  onMutation = () => {
    this.scrollToElementTarget.scrollIntoView();
  }

  onIntersection = (entries) => {
    const lastEntry = entries.slice(-1)[0];

    (lastEntry?.isIntersecting) ? this.observeMutations() : this.mutationObserver.disconnect();
  }

  disconnect() {
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }

  get observableElement() {
    if (this.hasObserableElementTarget) {
      return this.observableElementTarget;
    }

    return this.element;
  }
}
